/* eslint-disable */
import PopUpModal from '../../../components/common/popup';
import { Select } from '../form-fields/Select';
import InputField from '../../../components/common/input-field';
import './../text-editor/style.scss';
import Switch from '@mui/material/Switch';
import Button from '../../../components/common/button';
import AutoCompleteSelect from '../../../components/common/selectAutoComplete';
import { useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useRef, useState } from 'react';
import checkoutService from '../../api/checkoutService';
import { AxiosInstance } from 'axios';
import { IStoreProduct } from '../../interface/storeInterface';
import { debounce, map, uniq } from 'lodash';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { QuillEditor } from '../../../components/common/quill-editor/quill-editor';
import PreviewProduct from './PreviewProduct';
import { DeleteIcon } from '../../../assets/icons/delete';
import { UploadIcon } from '../../../assets/icons/upload';
import ImagePopup from '../../../components/common/image-selector/image-popup';
import { showNotification } from '../../api/constant';
import { IGetFunnelishConfig } from '../../interface/checkoutInterface';
import { paddingProps } from '../../puck/reusable-props/padding';
import { borderProps } from '../../puck/reusable-props/Border';

export interface IProductModalProps {
  productDetails: {
    id: number;
    name: string;
    imageUrl: string;
    price: number;
    variantid: number;
    label: string;
  };
  order: number;
  addAlias: boolean;
  aliasName: string;
  aliasImageUrl: string;
  aliasImageWidth?: string;
  aliasImageHeight?: string;
  totalCartPrice: string;
  defaultProduct: boolean;
  isDisplayPrice: boolean;
  displayPrice: string;
  isTag: boolean;
  tagText: string;
  isLeftTag: boolean;
  leftTagText: string;
  highlightColor: string;
  isHighlight: boolean;
  configId: null | number;
}

export const defaultProduct: IProductModalProps = {
  productDetails: {
    id: 0,
    name: '',
    label: '',
    imageUrl: '',
    price: 0,
    variantid: 0,
  },
  order: 1,
  addAlias: false,
  aliasName: '',
  aliasImageUrl: '',
  totalCartPrice: '',
  defaultProduct: false,
  isDisplayPrice: false,
  displayPrice: '',
  isTag: true,
  tagText: '',
  isLeftTag: false,
  leftTagText: '',
  highlightColor: '#FEC500',
  isHighlight: false,
  configId: null,
};

export interface ProductModalProps {
  value: {
    configId: number;
    products: IProductModalProps[];
  };
  onChange: (_value: {
    configId: number;
    products: IProductModalProps[];
  }) => void;
  baseService: AxiosInstance;
}

const ProductModal: React.FC<ProductModalProps> = ({
  value,
  onChange,
  baseService,
}) => {
  const [productModal, setProductModal] = useState(false);
  const [imagePopup, setimagePopup] = useState('');
  const [saveModal, setSaveModal] = useState(false);
  const [configOptions, setconfigOptions] = useState<IGetFunnelishConfig[]>([]);
  const [saveConfig, setSaveConfig] = useState(false);
  const [configName, setConfigName] = useState('');
  const [mode, setMode] = useState('design');
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState<IStoreProduct[]>([]);
  const [duplicateValue, setDuplicateValue] = useState(value);

  const storeID = searchParams.get('storeID') || '';
  const pageID = searchParams.get('pageID') || '';
  const [loading, setLoading] = useState(false);

  const position = useRef<number>();
  const [hasNextPage, setHasNextPage] = useState(true);
  const [page, setPage] = useState<{ page: number; title: string }>({
    page: 0,
    title: '',
  });
  const observerRef = useRef<IntersectionObserver | null>(null);

  const getProduct = async (data: {
    page: number;
    title: string;
    append: boolean;
  }) => {
    try {
      if (!storeID) return;
      setLoading(true);
      const res = await checkoutService.getAllStoreProducts(
        +storeID,
        baseService,
        {
          Limit: '100',
          Page: String(data?.page),
          Title: data?.title || '',
        },
      );
      if (res?.data?.Result) {
        if (res?.data?.TotalCount < 100) {
          setHasNextPage(false);
        }
        if (data?.append) {
          setProducts(prev => [...prev, ...(res?.data?.Result || [])]);
        } else {
          setProducts(res?.data?.Result || []);
        }
        setPage(prev => ({ ...prev, page: prev.page + 1 }));
      } else {
        setProducts([]);
        setPage({ page: 0, title: '' });
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  const lastElementRef = useCallback(
    (node: HTMLLIElement) => {
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && hasNextPage) {
          getProduct({ ...page, append: true });
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [page],
  );

  const handleChangeDropdownWithDebounce = useCallback(
    debounce(val => {
      setPage({ page: 0, title: val });
      getProduct({ page: 0, title: val, append: false });
    }, 500),
    [],
  );

  const setRef = (value: number) => {
    position.current = value;
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await checkoutService.getAllFunnelishConfig(
          +storeID,
          baseService,
        );
        setconfigOptions(response?.data?.Result || []);
      } catch (error) {
        console.error('Error fetching Funnelish config:', error);
      }
    })();
  }, []);

  return (
    <>
      <ToggleButtonGroup
        value={mode}
        exclusive
        className="w-full"
        onChange={(_, value) => {
          setMode(value);
          if (value === 'products') {
            setProductModal(true);
          } else {
            setProductModal(false);
          }
        }}
        aria-label="mode">
        <ToggleButton
          value="design"
          className="w-1/2"
          sx={{
            '&.Mui-selected': {
              backgroundColor: '#F90182',
              color: '#fff',
            },
          }}>
          Design
        </ToggleButton>
        <ToggleButton
          value="products"
          className="w-1/2"
          sx={{
            '&.Mui-selected': {
              backgroundColor: '#F90182',
              color: '#fff',
            },
          }}>
          Products
        </ToggleButton>
      </ToggleButtonGroup>
      <PopUpModal
        heading="Product Configuration"
        open={productModal}
        boxClassName="!w-full !max-w-[1500px]"
        handleClose={() => {
          setProductModal(!open);
          setMode('design');
          setDuplicateValue(value);
        }}
        buttons={[
          {
            buttonType: 'negative',
            buttonLabel: 'Close',
            buttonFunction: () => {
              setProductModal(false);
              setMode('design');
              setDuplicateValue(value);
            },
          },
          {
            buttonType: 'positive',
            buttonLabel:
              value?.products?.length !== duplicateValue?.products?.length
                ? 'Add'
                : 'update',
            disabled: false,
            buttonFunction: () => {
              const orders = map(duplicateValue.products, 'order');
              const hasDuplicates = orders.length !== uniq(orders).length;
              const duplicateSelected = duplicateValue.products?.filter(
                item => item.defaultProduct,
              );
              if (hasDuplicates) {
                showNotification('failed', 'Order numbers must be unique.');
              } else if (duplicateSelected?.length > 1) {
                showNotification(
                  'failed',
                  'Only one product can be selected as default.',
                );
              } else {
                setProductModal(false);
                setSaveModal(true);
              }
            },
          },
        ]}>
        <div>
          <label className="font-medium text-xs text-white">
            Add Product Configuration:
            <Select
              className="pagebuilder-theme rounded-md w-64 mt-2"
              value={duplicateValue.configId}
              fieldHeight="36"
              onChange={e => {
                const selectedConfig = configOptions.find(
                  option => +option.id === +e.target.value,
                );
                if (selectedConfig) {
                  setDuplicateValue({
                    ...JSON.parse(selectedConfig.config),
                    configId: +e.target.value,
                  });
                } else {
                  setDuplicateValue({
                    configId: 0,
                    products: [defaultProduct],
                  });
                }
              }}
              options={[
                { value: '', label: 'create new' },
                ...configOptions.map((option: IGetFunnelishConfig) => ({
                  value: option.id,
                  label: option.name,
                })),
              ]}
            />
          </label>
          <div className="grid grid-cols-2 gap-4 mt-4">
            {duplicateValue.products?.map((product, index) => {
              return (
                <div
                  className="grid grid-cols-2 border-2 !border-gray-600 rounded-2xl text-white max-w-4xl mx-auto"
                  key={index}>
                  <div className="col-span-2 flex items-center justify-between">
                    <div className="gap-4 p-3 flex items-center w-full">
                      <div className="font-medium text-xs whitespace-nowrap">
                        Add Shopify Product:
                      </div>
                      <AutoCompleteSelect
                        onOpen={() =>
                          getProduct({ page: 0, title: '', append: false })
                        }
                        selectClassName="w-full"
                        lastElementRef={lastElementRef}
                        position={position.current}
                        setPositionRef={value => setRef(value)}
                        loading={loading}
                        options={
                          !loading
                            ? products?.map(val => {
                                return {
                                  value: val?.id,
                                  label: `${val?.title} ($${val?.variants?.[0]?.price || 0}) (${val?.id})`,
                                };
                              })
                            : []
                        }
                        labelKey="label"
                        customHeight="40px"
                        onChange={e => {
                          if (e == null) {
                            const updatedValue = duplicateValue?.products?.map(
                              (item, i) =>
                                i === index
                                  ? {
                                      ...item,
                                      productDetails: {
                                        id: 0,
                                        name: '',
                                        imageUrl: '',
                                        label: '',
                                        price: 0,
                                        variantid: 0,
                                      },
                                    }
                                  : item,
                            );
                            setDuplicateValue({
                              ...duplicateValue,
                              products: updatedValue,
                            });
                            return;
                          }
                          const product = products?.find(
                            value => Number(value?.id) === e.value,
                          );
                          if (product) {
                            const updatedValue = duplicateValue?.products?.map(
                              (item, i) =>
                                i === index
                                  ? {
                                      ...item,
                                      productDetails: {
                                        id: product?.id,
                                        name: product?.title,
                                        label: `${product?.title} ($${product?.variants?.[0]?.price || 0}) (${product?.id})`,
                                        imageUrl: product?.image?.src || '',
                                        price:
                                          +product?.variants?.[0]?.price || 0,
                                        variantid:
                                          product?.variants?.[0]?.id || 0,
                                      },
                                      totalCartPrice:
                                        product?.variants?.[0]?.price || '0',
                                    }
                                  : item,
                            );
                            setDuplicateValue({
                              ...duplicateValue,
                              products: updatedValue,
                            });
                          }
                        }}
                        onInputChange={val =>
                          handleChangeDropdownWithDebounce(val)
                        }
                        placeholder="Select products"
                        value={
                          product?.productDetails?.label
                            ? {
                                label: product?.productDetails?.label,
                                value: -product?.productDetails?.id,
                              }
                            : null
                        }
                      />
                    </div>
                    {duplicateValue.products.length > 1 && (
                      <button
                        className="bg-transparent text-red-500 border border-red-500 rounded-md px-2 py-1 mr-3 hover:bg-red-500 hover:text-white"
                        onClick={() => {
                          const orderedArray = duplicateValue.products.reduce(
                            (acc: IProductModalProps[], item, i) => {
                              if (i !== index) {
                                acc.push({ ...item, order: acc.length + 1 });
                              }
                              return acc;
                            },
                            [] as IProductModalProps[],
                          );

                          setDuplicateValue({
                            ...duplicateValue,
                            products: orderedArray,
                          });
                        }}>
                        <DeleteIcon />
                      </button>
                    )}
                  </div>

                  <div className="col-span-2 grid grid-cols-4 border-b-2 !border-gray-600 h-16">
                    <label className="text-xs font-medium flex items-center justify-around gap-2 px-2">
                      Order:
                      <InputField
                        className="pagebuilder-theme h-9"
                        value={product?.order}
                        onChange={e => {
                          if (!isNaN(+e)) {
                            const updatedValue = duplicateValue.products.map(
                              (item, i) =>
                                i === index ? { ...item, order: +e } : item,
                            );
                            setDuplicateValue({
                              ...duplicateValue,
                              products: updatedValue,
                            });
                          }
                        }}
                      />
                    </label>
                    <div className="text-xs font-medium border-x-2 !border-gray-600 flex items-center justify-around gap-2 px-2">
                      <span>Add Alias:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.products?.map(
                            (item, i) =>
                              i === index
                                ? { ...item, addAlias: e.target.checked }
                                : item,
                          );
                          setDuplicateValue({
                            ...duplicateValue,
                            products: updatedValue,
                          });
                        }}
                        checked={product?.addAlias}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.addAlias
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.addAlias
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                    {product.addAlias && (
                      <>
                        <label className="text-xs font-medium border-r-2 !border-gray-600 flex items-center justify-around gap-2 px-2">
                          Name:
                          <InputField
                            className="pagebuilder-theme h-9"
                            value={product?.aliasName}
                            onChange={aliasName => {
                              const updatedValue =
                                duplicateValue?.products?.map((item, i) =>
                                  i === index ? { ...item, aliasName } : item,
                                );
                              setDuplicateValue({
                                ...duplicateValue,
                                products: updatedValue,
                              });
                            }}
                          />
                        </label>
                        <div className="text-xs font-medium flex items-center justify-around gap-2 px-2">
                          <span>Image:</span>
                          {product?.aliasImageUrl ? (
                            <div className="relative group w-[50px] h-[50px]">
                              <img
                                src={`${process.env.REACT_APP_S3_BUCKET_URL}${product.aliasImageUrl}`}
                                alt="Preview"
                                width={50}
                                height={50}
                                className="object-cover rounded"
                              />
                              <button
                                className="absolute top-0 right-0 w-5 h-5 bg-red-500 hover:bg-red-600 text-white rounded-full text-sm font-bold shadow-md transition-opacity opacity-0 group-hover:opacity-100"
                                onClick={() => {
                                  const updatedValue =
                                    duplicateValue?.products?.map((item, i) =>
                                      i === index
                                        ? { ...item, aliasImageUrl: '' }
                                        : item,
                                    );
                                  setDuplicateValue({
                                    ...duplicateValue,
                                    products: updatedValue,
                                  });
                                }}>
                                -
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => setimagePopup(String(index))}>
                              <UploadIcon />
                            </button>
                          )}
                          {String(index) === imagePopup && (
                            <ImagePopup
                              setPopupOpen={() => setimagePopup('')}
                              customId={`predefined-component${product.order}`}
                              handleSubmit={selectedImage => {
                                const updatedValue =
                                  duplicateValue?.products?.map((item, i) =>
                                    i === index
                                      ? {
                                          ...item,
                                          aliasImageUrl: selectedImage.imageUrl,
                                          aliasImageWidth: selectedImage?.width,
                                          aliasImageHeight:
                                            selectedImage?.height,
                                        }
                                      : item,
                                  );
                                setDuplicateValue({
                                  ...duplicateValue,
                                  products: updatedValue,
                                });
                              }}
                              image={{
                                imageUrl: '',
                                fileName: '',
                                storeID: '',
                                width: '',
                                height: '',
                              }}
                              isPopupOpen={!!imagePopup}
                              baseService={baseService}
                            />
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-span-2 grid grid-cols-3 border-b-2 !border-gray-600 h-16">
                    <label className="font-medium text-xs flex items-center justify-center gap-2 px-2 border-r-2 !border-gray-600">
                      Total Cart Price:
                      <InputField
                        value={product?.totalCartPrice}
                        isPrefixText="$"
                        className="pagebuilder-theme h-9"
                        onChange={e => {
                          const regex = /^\d+(\.\d{0,2})?$/;
                          const isNumber = regex.test(e);

                          if (isNumber || e === '') {
                            const updatedValue = duplicateValue?.products?.map(
                              (item, i) =>
                                i === index
                                  ? { ...item, totalCartPrice: e }
                                  : item,
                            );
                            setDuplicateValue({
                              ...duplicateValue,
                              products: updatedValue,
                            });
                          }
                        }}
                      />
                    </label>
                    <div className="text-xs font-medium flex items-center justify-center gap-2 px-2 border-r-2 !border-gray-600">
                      <span>Default Selected:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.products?.map(
                            (item, i) =>
                              i === index
                                ? { ...item, defaultProduct: e.target.checked }
                                : item,
                          );
                          setDuplicateValue({
                            ...duplicateValue,
                            products: updatedValue,
                          });
                        }}
                        checked={product?.defaultProduct}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.defaultProduct
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.defaultProduct
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                    <div className="text-xs font-medium flex items-center justify-center">
                      <span className="ps-2">Highlight:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.products?.map(
                            (item, i) =>
                              i === index
                                ? { ...item, isHighlight: e.target.checked }
                                : item,
                          );
                          setDuplicateValue({
                            ...duplicateValue,
                            products: updatedValue,
                          });
                        }}
                        checked={product?.isHighlight}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.isHighlight
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.isHighlight
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                      <div className="text-xs font-medium flex items-center pt-2 px-0">
                        {product?.isHighlight && (
                          <>
                            <span>Highlight Color:</span>
                            <input
                              type="color"
                              className="pagebuilder-theme h-8 w-8 p-0"
                              value={product?.highlightColor}
                              onChange={e => {
                                const updatedValue =
                                  duplicateValue?.products?.map((item, i) =>
                                    i === index
                                      ? {
                                          ...item,
                                          highlightColor: e.target.value,
                                        }
                                      : item,
                                  );
                                setDuplicateValue({
                                  ...duplicateValue,
                                  products: updatedValue,
                                });
                              }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Updated row for Displayed Price, Add Tag, and Add Another Tag */}
                  <div className="col-span-2 grid grid-cols-3 border-b-2 !border-gray-600 h-12">
                    <div className="text-xs font-medium flex items-center gap-2 px-2">
                      <span>Displayed Price:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.products?.map(
                            (item, i) =>
                              i === index
                                ? { ...item, isDisplayPrice: e.target.checked }
                                : item,
                          );
                          setDuplicateValue({
                            ...duplicateValue,
                            products: updatedValue,
                          });
                        }}
                        checked={product?.isDisplayPrice}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.isDisplayPrice
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.isDisplayPrice
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                    <div className="text-xs font-medium flex items-center gap-2 px-2 border-x-2 !border-gray-600">
                      <span>Add Tag:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.products?.map(
                            (item, i) =>
                              i === index
                                ? { ...item, isTag: e.target.checked }
                                : item,
                          );
                          setDuplicateValue({
                            ...duplicateValue,
                            products: updatedValue,
                          });
                        }}
                        checked={product?.isTag}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.isTag ? 'green' : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.isTag ? 'green' : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                    <div className="text-xs font-medium flex items-center gap-2 px-2">
                      <span>Add Left Vertical Tag:</span>
                      <Switch
                        onChange={e => {
                          const updatedValue = duplicateValue?.products?.map(
                            (item, i) =>
                              i === index
                                ? { ...item, isLeftTag: e.target.checked }
                                : item,
                          );
                          setDuplicateValue({
                            ...duplicateValue,
                            products: updatedValue,
                          });
                        }}
                        checked={product?.isLeftTag}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: product?.isLeftTag
                              ? 'green'
                              : 'red',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: product?.isLeftTag
                              ? 'green'
                              : 'red',
                          },
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                  </div>
                  <div className="col-span-2 grid grid-cols-3">
                    <div>
                      {product.isDisplayPrice && (
                        <QuillEditor
                          value={product.displayPrice}
                          enableLink={false}
                          onChange={e => {
                            const updatedValue = duplicateValue?.products?.map(
                              (item, i) =>
                                i === index
                                  ? { ...item, displayPrice: e }
                                  : item,
                            );
                            setDuplicateValue({
                              ...duplicateValue,
                              products: updatedValue,
                            });
                          }}
                          id={index * 2 + 1}
                        />
                      )}
                    </div>
                    <div className="border-x-2 !border-gray-600">
                      {product.isTag && (
                        <QuillEditor
                          value={product.tagText}
                          enableLink={false}
                          onChange={e => {
                            const updatedValue = duplicateValue?.products?.map(
                              (item, i) =>
                                i === index ? { ...item, tagText: e } : item,
                            );
                            setDuplicateValue({
                              ...duplicateValue,
                              products: updatedValue,
                            });
                          }}
                          id={index * 2 + 2}
                        />
                      )}
                    </div>
                    <div className="border-x-2 !border-gray-600">
                      {product?.isLeftTag && (
                        <QuillEditor
                          value={product.leftTagText}
                          enableLink={false}
                          onChange={e => {
                            const updatedValue = duplicateValue?.products?.map(
                              (item, i) =>
                                i === index
                                  ? { ...item, leftTagText: e }
                                  : item,
                            );
                            setDuplicateValue({
                              ...duplicateValue,
                              products: updatedValue,
                            });
                          }}
                          id={index * 2 + 500}
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <Button
            type="button"
            onClick={() => {
              const newProduct: IProductModalProps = {
                ...defaultProduct,
                order: duplicateValue.products.length + 1,
              };
              setDuplicateValue({
                ...duplicateValue,
                products: [...duplicateValue.products, newProduct],
              });
            }}
            label="+Add Product"
            className="mt-2 mb-8 !text-[#6AD2FF] w-full !bg-[#1D2634] hover:opacity-80"
          />
          <div className="mx-auto bg-[#1F2937] rounded-md grid justify-center py-4 w-[400px]">
            <span className="text-white place-self-center pb-2">
              Product Selection Review
            </span>

            <div className="bg-white w-96 p-2 rounded-md">
              <div className="flex justify-between text-sm font-medium mb-2">
                <span>Product</span>
                <span>Price</span>
              </div>

              <hr className="border-t-2 border-gray-300 mb-2" />
              <div className="grid grid-cols-1 gap-3">
                <PreviewProduct
                  data={duplicateValue.products}
                  maxContainerWidth="100%"
                  tagPosition="top"
                  borderForProducts={{
                    deviceType: 'desktop',
                    borderBottomLeft: {
                      desktop: '10',
                      tablet: '10',
                      mobile: '10',
                    },
                    borderBottomRight: {
                      desktop: '10',
                      tablet: '10',
                      mobile: '10',
                    },
                    borderTopLeft: {
                      desktop: '10',
                      tablet: '10',
                      mobile: '10',
                    },
                    borderTopRight: {
                      desktop: '10',
                      tablet: '10',
                      mobile: '10',
                    },
                    borderTopWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderRightWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderBottomWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderLeftWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderWidth: {
                      desktop: 1,
                      tablet: 1,
                      mobile: 1,
                    },
                    borderStyle: {
                      desktop: 'border-solid',
                      tablet: 'border-solid',
                      mobile: 'border-solid',
                    },
                    borderColor: {
                      desktop: '#a3a3a3',
                      tablet: '#a3a3a3',
                      mobile: '#a3a3a3',
                    },
                  }}
                  radioColor="#2563EB"
                  radioSize="20"
                  productTitle={{
                    weight: {
                      mobile: 'font-semibold',
                      tablet: 'font-semibold',
                      desktop: 'font-semibold',
                    },
                    deviceType: 'desktop',
                    text: '',
                    textColor: {
                      mobile: '#000000',
                      tablet: '#000000',
                      desktop: '#000000',
                    },
                    hoverColor: {
                      mobile: '#000000',
                      tablet: '#000000',
                      desktop: '#000000',
                    },
                    fontSize: {
                      mobile: 'text-sm',
                      tablet: 'text-sm',
                      desktop: 'text-sm',
                    },
                  }}
                  currentDeviceType="desktop"
                  pageId={pageID}
                  image={{
                    height: {
                      desktop: '40',
                      mobile: '40',
                      tablet: '40',
                    },
                    maxWidth: {
                      desktop: '40',
                      mobile: '40',
                      tablet: '40',
                    },
                    deviceType: 'desktop',
                  }}
                  tagStyles={{
                    isBlink: 'no',
                    borderTopLeft: '0',
                    borderTopRight: '0',
                    borderBottomLeft: '0',
                    borderBottomRight: '0',
                    ...paddingProps,
                    backgroundColor: '#FFFFFF',
                  }}
                  selectedProduct={
                    duplicateValue?.products?.find(item => item.defaultProduct)
                      ?.productDetails.id ??
                    (duplicateValue?.products?.[0]?.productDetails.id || 0)
                  }
                  setSelectedProduct={() => {}}
                  selectionStyle={{
                    isToggle: true,
                    bannerStyle: {
                      backgroundColor: '#ffffff',
                      border: { ...borderProps.border },
                      shadow: 'none',
                      titleColor: '#000000',
                    },
                  }}
                  leftTagStyles={{
                    isBlink: 'no',
                    borderTopLeft: '0',
                    borderTopRight: '0',
                    borderBottomLeft: '0',
                    borderBottomRight: '0',
                    ...paddingProps,
                    backgroundColor: '#FFFFFF',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        heading="Save Product Configuration"
        open={saveModal}
        buttons={[
          {
            buttonType: 'negative',
            buttonLabel: 'Cancel',
            buttonFunction: () => {
              setMode('design');
              setSaveModal(false);
              setProductModal(true);
            },
          },
          {
            buttonType: 'positive',
            buttonLabel:
              value?.products?.length !== duplicateValue?.products?.length
                ? 'Add'
                : 'update',
            disabled: loading,
            buttonFunction: async () => {
              let data;
              try {
                setLoading(true);
                if (saveConfig) {
                  data = await checkoutService.createFunnelishConfig(
                    baseService,
                    {
                      config: JSON.stringify(duplicateValue),
                      name: configName,
                      storeId: +storeID,
                    },
                  );
                }
                await checkoutService.saveFunnelishProducts(baseService, {
                  productIds: duplicateValue?.products?.map(
                    item => item?.productDetails?.id,
                  ),
                  storeId: +storeID,
                  productConfigurationId:
                    data?.data?.Result?.id || duplicateValue?.configId,
                  pageId: +pageID,
                });
                setLoading(false);
              } catch (error) {
                console.error('Error saving product configuration:', error);
                setLoading(false);
              } finally {
                setLoading(false);
              }
              onChange({
                ...duplicateValue,
                configId: data?.data?.Result?.id || duplicateValue?.configId,
              });
              setSaveModal(false);
              setMode('design');
            },
          },
        ]}>
        <div className="grid text-white gap-4">
          <label>
            Do you want to save Product Configuration to use for other funnels?
          </label>
          <div className="flex items-center">
            <label>No</label>
            <Switch
              onChange={e => setSaveConfig(e.target.checked)}
              checked={saveConfig}
              sx={{
                '& .MuiSwitch-thumb': {
                  backgroundColor: saveConfig ? 'green' : 'red',
                },
                '& .MuiSwitch-track': {
                  backgroundColor: saveConfig ? 'green' : 'red',
                },
              }}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <label>Yes</label>
          </div>
          {saveConfig && (
            <>
              <label className="text-xs font-medium">
                Product Configuration Name:
              </label>
              <InputField
                className="pagebuilder-theme h-9 w-60"
                value={configName}
                onChange={e => setConfigName(e)}
              />
            </>
          )}
        </div>
      </PopUpModal>
    </>
  );
};

export default ProductModal;
